<template>
  <div
    v-if="loading"
    class="tw-flex tw-items-center tw-justify-center tw-h-full"
  >
    <div
      class="sf-spinner sf-spinner-l sf-spinner-primary"
      data-testid="chart-load-state-spinner"
    />
  </div>
  <div
    v-else-if="errored"
    class="tw-flex tw-items-center tw-justify-center tw-h-full"
  >
    <div
      class="tw-text-sm tw-text-sf-neutral-light-1 tw-text-center"
      data-testid="chart-load-state-error"
    >
      {{ errorText }}
    </div>
  </div>
  <SfEchartsRenderer
    v-else-if="graphData"
    :graph-data="graphData"
    height="100%"
    :hide-x-axis-labels="hideXAxisLabels"
    :compact-y-axis="compactYAxis"
    @series-click="onSeriesClick"
  />
</template>

<script setup lang="ts">
import SfEchartsRenderer from '@app/application/report/screens/graph-editor/components/sf-echarts-renderer.vue'
import type {
  GraphData,
  SeriesTarget,
} from '@app/application/report/screens/graphs-echarts/types'
import { useReportGraphsDrawer } from '@app/application/report/store/use-report-graphs-drawer'
import { useReportRowHighlight } from '@app/application/report/store/use-report-row-highlight'

defineOptions({ name: 'ChartLoadState' })

interface Props {
  graphData: GraphData | null
  loading?: boolean
  errored?: boolean
  errorText?: string
  hideXAxisLabels?: boolean
  compactYAxis?: boolean
}

withDefaults(defineProps<Props>(), {
  loading: false,
  errored: false,
  errorText: '',
  hideXAxisLabels: false,
  compactYAxis: false,
})

// Bridge chart-metric clicks (Vue) to the server-rendered report table.
// Close the drawer's full-screen overlay first so the rows are visible, then
// set the target rows — the Stimulus controller on #report does the scroll and
// visual treatment. Resolve the stores lazily so the component can be
// unit-mounted without an active Pinia.
function onSeriesClick(target: SeriesTarget): void {
  const drawerStore = useReportGraphsDrawer()
  if (drawerStore.fullscreen) drawerStore.closeFullscreen()
  useReportRowHighlight().highlight(target)
}
</script>
